import Geocode, { Attributes } from 'types/Geocode';

export default class Google implements Geocode {
  googleData: google.maps.GeocoderResult;

  constructor(googleData: google.maps.GeocoderResult) {
    this.googleData = googleData;
  }

  addressComponentWithType(type: string): google.maps.GeocoderAddressComponent | undefined {
    return this.googleData.address_components.find((addressComponent) =>
      addressComponent.types.includes(type)
    );
  }

  get stateAbbreviation(): string {
    // eslint-disable-next-line camelcase
    return this.addressComponentWithType('administrative_area_level_1')?.short_name as string;
  }

  get city(): string {
    // eslint-disable-next-line camelcase
    return this.addressComponentWithType('locality')?.long_name as string;
  }

  get latitude(): number {
    const { lat } = this.googleData.geometry.location;
    // this type can be scalar or function depending on whether it's serialized
    return typeof lat === 'function' ? lat() : lat;
  }

  get longitude(): number {
    const { lng } = this.googleData.geometry.location;
    // this type can be scalar or function depending on whether it's serialized
    return typeof lng === 'function' ? lng() : lng;
  }

  get zip(): string {
    // eslint-disable-next-line camelcase
    return this.addressComponentWithType('postal_code')?.short_name as string;
  }

  toJSON(): Attributes {
    return {
      city: this.city,
      stateAbbreviation: this.stateAbbreviation,
      latitude: this.latitude,
      longitude: this.longitude,
      zip: this.zip,
    };
  }
}
